export function getErrorMessage(error: unknown): string{
    // On occasion errors are thrown as strings (not recomended)
    if( typeof error === 'string') {
        return error;
    }
    if (isErrorObject(error)) {
        // Convert the unknown object to error type and return the message
        const errorObject = error as Error;
        console.error(errorObject.stack);       
        return `${errorObject.message}`;
    }
    // The type doesn't match what we expect an error to be, returns a message so we can troubleshoot
    return (`Invalid error type ${error}`)
}
// Duck types the passed object to an error, will return true if it matches
function isErrorObject(error: any): boolean{
    return (!!error && !!error.stack && !!error.message);
}